export default {
  'advertisements': 'Anuncios',
  'advertisements.total': 'Total de anuncios',
  'advertisements.total-investment': 'Inversión total de anuncios',
  'advertisements.average': 'Media por anuncio',
  'advertisements.active': 'Activos',
  'advertisements.paused': 'Pausados',
  'advertisements.pending': 'Pendientes',
  'advertisements.percentages-states': 'Porcentajes de estados de anuncios',
  'advertisements.quantity-sector': 'Cantidad de anuncios por sector',
};
